import { createEntityAdapter, createSlice } from '@reduxjs/toolkit';
import { actionTypes as dataFetchActionTypes } from '@bufferapp/async-data-fetch';
import { actionTypes as queueActionTypes } from '~/queue/reducer';
import { PublishingPost } from '~/post/types.generated';
import type { RootState } from '~/store';
import { RpcUpdate } from './types';

const postsAdapter = createEntityAdapter<PublishingPost | RpcUpdate>();

const postFetchReducerAction = (state, action) => {
  postsAdapter.setMany(state, action.result.updates);
};

export const postsSlice = createSlice({
  name: 'posts',
  initialState: postsAdapter.getInitialState(),
  reducers: {
    postAdded: postsAdapter.addOne,
    postUpdated: postsAdapter.updateOne,
    postsReceived: postsAdapter.setMany,
  },
  extraReducers: {
    [`draftPosts_${dataFetchActionTypes.FETCH_SUCCESS}`]: (state, action) => {
      postsAdapter.setAll(state, action.result.drafts);
    },
    [`sentPosts_${dataFetchActionTypes.FETCH_SUCCESS}`]: postFetchReducerAction,
    [`pendingTiktok_${dataFetchActionTypes.FETCH_SUCCESS}`]:
      postFetchReducerAction,
    [`pastRemindersPosts_${dataFetchActionTypes.FETCH_SUCCESS}`]:
      postFetchReducerAction,
    [`getStoryGroups_${dataFetchActionTypes.FETCH_SUCCESS}`]:
      postFetchReducerAction,
    [queueActionTypes.POST_UPDATED]: (state, action) => {
      postsAdapter.setOne(state, action.post);
    },
    [`getCampaign_${dataFetchActionTypes.FETCH_SUCCESS}`]: (state, action) => {
      postsAdapter.setMany(state, action.result.items);
    },
  },
});

const { postsReceived } = postsSlice.actions;

// globalized selectors
const { selectById: selectPostById } = postsAdapter.getSelectors(
  (state: RootState) => state[postsSlice.name]
);

export { postsReceived, selectPostById };
